/**
 * Created by lu on 2017/8/7.
 */
var nb = require('../../nb');
// var alerts = require('../Alerts');
var uploadImage = require('../../io/' + process.env.APP_ENV + '/uploadImage');
var maxCount = 1;  //图片数量
var maxSize = 1;  //图片大小 M
module.exports = nb.define({
    parent: nb.Model,
    mapping: {
        imgList: require('./ImgList')
    },
    method: {
        init: function () {
            var self = this;
            // this.set('selectedImgArr',[]);
            this.set('loadingVisible', 'hide');
            this.set('maxCount', maxCount);

            this.onChange('deleteIndex', function (inEvent, inIndex) { //删除
                var array = this.get('imgList').get('items'); //selectedImgUrl
                this.set('uploadWidth', ''); //样式清空
                array.splice(inIndex, 1);//todo
                this.setOpts({
                    imgList: {
                        items: array
                    }
                });

            }, this);

            //点击上传
            this.onChange('selectedFile', function (inEvent, inFile) {
                // this.set('selectedImgArr', []);
                this.set('uploadWidth', 'hasPhoto');
                var files = inFile.files;
                if (files.length === 0) {
                    return;
                }
                // if(files.length>0){  //清空原来图片 val
                //     inFile[0].val("")
                // }
                var flag = false;
                $.each(files, function (inIndex, inItem) {
                    var size = Math.round(files[inIndex].size / 1024 / 1024);
                    if (size > maxSize) {  //  >=
                        flag = true;
                        return false;
                    }
                });
                if (flag) {
                    nb.toast.setOpts({
                        text: '图片大小不能超过1M',
                        status: 'danger'
                    });
                    self.set('imgUp', '');
                    this.set('uploadWidth', ''); //样式清空
                    return;
                }
                // var array = self.get('selectedImgArr') || [];
                var array = [];
                var selectedCount = array.length;
                var count = files.length;
                var newCount = selectedCount + count;
                if (newCount > this.get('maxCount')) {
                    // alerts.setOpts({
                    //     text: '最多上传1张图片',
                    //     status: 'alert-danger'
                    // });
                    nb.toast.setOpts({
                        text: '照片数量超过限制',//最多上传1张图片
                        status: 'danger'
                    });
                    return;
                }
                this.set('loading', true);
                for (var i = 0; i < count; i++) {
                    //files[i] 单个图片
                    //array 当前选中的图片
                    //本次上传的数量
                    //selectedCount 当前选中的图片数量
                    this.getPic(files[i], array, count, selectedCount);//count
                }
            }, this);

            //点击删除
            this.onChange('selectedImgArr', function (inEvent, inArray) {
                // if (inArray.length === 0) {
                //     this.get('imgList').set('items', []);
                // } else {
                //     // this.get('imgList').set('items', inArray);
                //
                // }
                this.uploadImgList();
                this.set('imgListReady', new Date());
            }, this);
            this.onChange('loading', function (inEvent, inFlag) {
                if (inFlag) {
                    this.set('loadingVisible', '');//图片上传中
                } else {
                    this.set('loadingVisible', 'hide');
                }
            }, this);
        },
        getPic: function (inFile, inArray, inCount, inSelectedCount) {
            var self = this;
            var reader = new FileReader();
            reader.onload = function () {
                var src = reader.result;  //reader.result
                inArray.unshift({src: src, file: inFile});
                if (inArray.length === inCount + inSelectedCount) {
                    self.set('selectedImgArr', inArray);
                    self.set('loading', false);
                }
            };
            reader.readAsDataURL(inFile);
        },

        uploadImgList: function (inOpts) {
            var self = this;
            var imgList = this.get('selectedImgArr');
            var items = this.get('imgList').get('items') || [];
            var allItems = [];
            // var scope  =inOpts.scope;
            // var callback = inOpts.callback;
            if (!imgList || imgList.length <= 0) {
                return
            }
            var formData = new FormData();
            $.each(imgList, function (index, item) {
                if (item.file) {
                    formData.append('files', item.file);  //  item.file
                }
            });

            if (items.length > 0) {
                $.each(items, function (index, item) {
                    allItems.push({
                        src: item.get('src')
                    })
                });
            }
            this.set('loading', true);
            uploadImage({
                data: {
                    type: 'ratingImgList'
                },
                formData: formData,
                scope: this,
                success: function (inResp) {
                    self.set('loading', false);
                    // if(callback){
                    //     callback.call(scope,inResp)
                    // }   imgList
                    $.each(inResp, function (index, item) {  //真实环境inResp.imgList
                        allItems.push({ //前unshift  后push
                            src: item //.src
                        });
                    });                                             //allItems
                    self.get('imgList').set('items', allItems);    //todo  真实环境返回inResp下  http://xxxxx.jpg
                },
                error: function (inResp) {  //todo
                    nb.toast.setOpts({
                        text: '上传失败，请重新上传！',
                        status: 'danger'
                    });
                }
            });

        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/model/uploadImg/uploadImg.js
// module id = 76
// module chunks = 3 4 8 19 29